import { makeStyles } from 'tss-react/mui';
import { selectClasses } from '@mui/material';
import { ViewSwitcher } from '@devexpress/dx-react-scheduler-material-ui';

const useStyles = makeStyles()({
  switcherComponent: {
    [`& .${selectClasses.select}`]: {
      minHeight: 0,
    },
    '& > fieldset': {
      top: '-3px',
      bottom: '2px',
    },
  },
});

export const SwitcherComponent = (props: ViewSwitcher.SwitcherProps) => {
  const { classes } = useStyles();
  return (
    <ViewSwitcher.Switcher
      className={classes.switcherComponent}
      {...props}
    ></ViewSwitcher.Switcher>
  );
};
